import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Dropdown, Option, OptionKey, RawButton, Text } from '@common-fe/common-fe';
import styled from 'styled-components';

import { ALL_KEY } from '@/common/constants';

const Wrapper = styled(Box)`
  &:hover {
    background: ${({ theme }) => theme.colors.accentContainer};
  }
`;
const OPTIONS: Option[] = [
  {
    key: ALL_KEY,
    title: 'All',
  },
  {
    key: '1',
    title: '$1',
  },
  {
    key: '5',
    title: '$5',
  },
  {
    key: '10',
    title: '$10',
  },
];
interface Props {
  value: OptionKey;
  onChangeValue: (values: OptionKey) => void;
}
const TransactionsAmountSelect: React.FC<Props> = ({ value, onChangeValue }) => {
  // const options = useAmountOptions();
  const { t } = useTranslation();

  const [isExpanded, setExpanded] = useState(false);

  const currentTitle = useMemo(() => {
    if (value) {
      return OPTIONS.find((option) => option.key === value)?.title;
    }
    return OPTIONS[0].title;
  }, [value]);

  return (
    <Box width="240px" data-testid="roles-level_dropdown">
      <Dropdown
        placeholder="Placeholder"
        isClickOutside={true}
        testId="transaction-amount-select"
        prefix="Min. Amount"
        expanded={isExpanded}
        title={
          <Text title={currentTitle} color="textAccent" truncate>
            {currentTitle}
          </Text>
        }
        onSetExpanded={setExpanded}
      >
        <Box direction="column" data-testid="" pad="s">
          <Box margin={{ bottom: 'xs' }}>
            <Text size="small" weight={500} data-testid="transaction-amount-select_text">
              {t('Filter your activities to show only those that exceed a set amount')}
            </Text>
          </Box>
          {OPTIONS.map((item) => (
            <RawButton
              data-testid={`transaction-amount-select_${item.key}_button`}
              key={item.key}
              onClick={() => onChangeValue(item.key as string)}
            >
              <Wrapper round="fieldRound" pad={{ horizontal: 'xs', vertical: 'xs' }}>
                <Text weight={item.key === value ? 700 : 400}>{item.title}</Text>
              </Wrapper>
            </RawButton>
          ))}
        </Box>
      </Dropdown>
    </Box>
  );
};

export default TransactionsAmountSelect;
